export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/vercel/path0/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/AdBattle',
    name: '/AdBattle',
    component: () => import('/vercel/path0/src/pages/AdBattle.vue'),
    /* no children */
  },
  {
    path: '/adminDashboard',
    /* internal name: '/adminDashboard' */
    /* no component */
    children: [
      {
        path: 'Admin',
        name: '/adminDashboard/Admin',
        component: () => import('/vercel/path0/src/pages/adminDashboard/Admin.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/AdventurePages',
    /* internal name: '/AdventurePages' */
    /* no component */
    children: [
      {
        path: 'Jail',
        name: '/AdventurePages/Jail',
        component: () => import('/vercel/path0/src/pages/AdventurePages/Jail.vue'),
        /* no children */
      },
      {
        path: 'ResultBase',
        name: '/AdventurePages/ResultBase',
        component: () => import('/vercel/path0/src/pages/AdventurePages/ResultBase.vue'),
        /* no children */
      },
      {
        path: 'Reward',
        name: '/AdventurePages/Reward',
        component: () => import('/vercel/path0/src/pages/AdventurePages/Reward.vue'),
        /* no children */
      },
      {
        path: 'Save',
        name: '/AdventurePages/Save',
        component: () => import('/vercel/path0/src/pages/AdventurePages/Save.vue'),
        /* no children */
      },
      {
        path: 'Store',
        name: '/AdventurePages/Store',
        component: () => import('/vercel/path0/src/pages/AdventurePages/Store.vue'),
        /* no children */
      },
      {
        path: 'StoryBase',
        name: '/AdventurePages/StoryBase',
        component: () => import('/vercel/path0/src/pages/AdventurePages/StoryBase.vue'),
        /* no children */
      },
      {
        path: 'StoryCharacter',
        name: '/AdventurePages/StoryCharacter',
        component: () => import('/vercel/path0/src/pages/AdventurePages/StoryCharacter.vue'),
        /* no children */
      },
      {
        path: 'StoryIntro',
        name: '/AdventurePages/StoryIntro',
        component: () => import('/vercel/path0/src/pages/AdventurePages/StoryIntro.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/battle_area',
    name: '/battle_area',
    component: () => import('/vercel/path0/src/pages/battle_area.vue'),
    /* no children */
  },
  {
    path: '/BattleAreaAi',
    name: '/BattleAreaAi',
    component: () => import('/vercel/path0/src/pages/BattleAreaAi.vue'),
    /* no children */
  },
  {
    path: '/BustedBase',
    name: '/BustedBase',
    component: () => import('/vercel/path0/src/pages/BustedBase.vue'),
    /* no children */
  },
  {
    path: '/CardsView',
    name: '/CardsView',
    component: () => import('/vercel/path0/src/pages/CardsView.vue'),
    /* no children */
  },
  {
    path: '/CharacterSelection',
    name: '/CharacterSelection',
    component: () => import('/vercel/path0/src/pages/CharacterSelection.vue'),
    /* no children */
  },
  {
    path: '/CharacterSelectionAi',
    name: '/CharacterSelectionAi',
    component: () => import('/vercel/path0/src/pages/CharacterSelectionAi.vue'),
    /* no children */
  },
  {
    path: '/Lander',
    name: '/Lander',
    component: () => import('/vercel/path0/src/pages/Lander.vue'),
    /* no children */
  },
  {
    path: '/Landing',
    name: '/Landing',
    component: () => import('/vercel/path0/src/pages/Landing.vue'),
    /* no children */
  },
  {
    path: '/loader',
    name: '/loader',
    component: () => import('/vercel/path0/src/pages/loader.vue'),
    /* no children */
  },
  {
    path: '/LoadSkipper',
    name: '/LoadSkipper',
    component: () => import('/vercel/path0/src/pages/LoadSkipper.vue'),
    /* no children */
  },
  {
    path: '/MultiPlayer',
    name: '/MultiPlayer',
    component: () => import('/vercel/path0/src/pages/MultiPlayer.vue'),
    /* no children */
  },
  {
    path: '/NotFound',
    name: '/NotFound',
    component: () => import('/vercel/path0/src/pages/NotFound.vue'),
    /* no children */
  },
  {
    path: '/OnlineBase',
    name: '/OnlineBase',
    component: () => import('/vercel/path0/src/pages/OnlineBase.vue'),
    /* no children */
  },
  {
    path: '/ReadyComponent',
    name: '/ReadyComponent',
    component: () => import('/vercel/path0/src/pages/ReadyComponent.vue'),
    /* no children */
  },
  {
    path: '/Test',
    name: '/Test',
    component: () => import('/vercel/path0/src/pages/Test.vue'),
    /* no children */
  },
  {
    path: '/Victory',
    name: '/Victory',
    component: () => import('/vercel/path0/src/pages/Victory.vue'),
    /* no children */
  },
  {
    path: '/WelcomeDesktop',
    name: '/WelcomeDesktop',
    component: () => import('/vercel/path0/src/pages/WelcomeDesktop.vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

